<script>
	// Stores 
	import { textSite } from '../store.js';    

	// Componentes
	import { link } from "svelte-routing";
	import PageHeader from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Garantias Locatícias';    
	
	let itens = [{}];

	let garantias = [
		{
			name: 'Fiador',
			icon: `<i class="fas fa-user-shield"></i>`,
			text: `A pessoa física que seja proprietária de dois imóveis localizados em Porto Alegre ou Região Metropolitana, livre de ônus e de ação real e pessoal reipersecutória. Excepcionalmente, analisamos cadastro de candidato a fiador com imóveis no interior do estado.`,
		},
		{
			name: 'Seguro de fiança locatícia',
			icon: `<i class="fas fa-shield-alt"></i>`,
			text: `Garantia contratada pelo locatário com uma seguradora indicada pela Dinmar Imóveis, para a qual o inquilino pagará anualmente o Seguro de Fiança Locatícia. O valor (prêmio) do seguro anual é calculado pela Dinmar Imóveis, seguindo tabela fornecida pela Seguradora, tendo como base o valor de um aluguel e meio, mais encargos da locação pretendida (IPTU, condomínio, etc.).`,
		},
		{
			name: 'Caução de Bem imóvel',
			icon: `<i class="fas fa-home"></i>`,
			text: `O locatário poderá hipotecar ao Locador um imóvel de sua propriedade ou de terceiros, localizado em Porto Alegre ou Região Metropolitana. Para isso é necessária a formalização de uma escritura pública de hipoteca que será assinada pelo locatário, pelo proprietário do imóvel a ser hipotecado e pelo locador ou seu procurador. Antes de formalizar a escritura, o Tabelionato exige uma cópia atualizada da matrícula do imóvel a ser hipotecado e a certidão negativa de ônus e de ações reais e pessoais reipersecutória. O custo da lavratura da escritura e o registro da mesma na matrícula do imóvel será do inquilino e pagável à vista e diretamente aos Cartórios.`
		},
		{
			name: 'Titulo de Capitalização',
			icon: `<i class="fas fa-money-check-alt"></i>`,
			text: `O locatário subscreve um titulo de capitalização (deposita numa empresa de Capitalização) o valor equivalente a 12 vezes o valor do aluguel e encargos da locação (IPTU, condomínio, etc.) do imóvel pretendido. O depósito/pagamento do título será a vista, diretamente para a Capitalizadora, após a aprovação do cadastro do inquilino pela Dinmar Imóveis e antes da assinatura do contrato de locação. O valor do título será resgatado pelo locatário, devidamente corrigido, após rescindida a locação e entrega das chaves do imóvel, após quitados todos os valores devidos ao locador. A capitalização é semelhante a poupança e concorre a prêmios.`,
		}
	];
</script>

<section class="conteudo-internas">
	<PageHeader title={titlePage}></PageHeader>
	<div class="container">
		<p>Formas de garantia ao contrato de Locação:</p>
		<div class="box-itens-icon">
			{#each garantias as garantia}
				<div class="item">
					<div class="icon">
						{@html garantia.icon}
					</div>
					<div class="infos">
						<h2 class="title">{garantia.name}</h2>
						<p>{@html garantia.text}</p>
					</div>
				</div>
			{/each}
		</div>
		<div class="button text-center mt-40">        
			<a href="/documentacao-necessaria" use:link replace title="Confira a documentação necessária para locação" class="btn btn-secondary">Confira a documentação necessária para locação <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> </a>
		</div>
	</div>
</section>